import { render, staticRenderFns } from "./certificateDetail.vue?vue&type=template&id=e06b8a4e&scoped=true&"
import script from "./certificateDetail.vue?vue&type=script&lang=js&"
export * from "./certificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./certificateDetail.vue?vue&type=style&index=0&id=e06b8a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06b8a4e",
  null
  
)

export default component.exports